/*!

=========================================================
* Purity UI Dashboard PRO - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/purity-ui-dashboard-pro
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)

* Design by Creative Tim & Coded by Simmmple

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

export const columnsData1 = [
  {
    Header: "NAME",
    accessor: "name",
  },
  {
    Header: "POSITION",
    accessor: "position",
  },
  {
    Header: "OFFICE",
    accessor: "office",
  },
  {
    Header: "AGE",
    accessor: "age",
  },
  {
    Header: "START DATE",
    accessor: "date",
  },
  {
    Header: "SALARY",
    accessor: "salary",
  },
];

export const columnsData2 = [
  {
    Header: "A.A.",
    accessor: "id",
  },
  {
    Header: "HMEPOMHNIA",
    accessor: "date",
  },
  {
    Header: "ΚΑΤΑΣΤΑΣΗ",
    accessor: "status",
  },
  {
    Header: "ΠΕΛΑΤΗΣ",
    accessor: "customer",
  },
  {
    Header: "ΟΔΗΓΟΣ",
    accessor: "product",
  },
  {
    Header: "ΣΥΝΟΛΟ",
    accessor: "revenue",
  },
];

export const ClientColumn = [
  {
    Header: "Client Name",
    accessor: "fullname",
  },
  {
    Header: "Category",
    accessor: "customerCategory",
  },
  {
    Header: "Assigned Driver",
    accessor: "driver",
  },
  {
    Header: "Phone Number",
    accessor: "phone",
  },
];

export const OrderColumn = [
  {
    Header: "Αριθμός Παραγγελίας",
    accessor: "αριθμός_παραγγελίας",
  },
  {
    Header: "Ημερομηνία Παραγγελίας",
    accessor: "ημερομηνία_παραγγελίας",
  },
  {
    Header: "Ημερομηνία Παράδοσης",
    accessor: "ημερομηνία_παράδοσης",
  },
  {
    Header: "Κατάσταση Παραγγελίας",
    accessor: "κατάσταση_παραγγελίας",
  },
  {
    Header: "Όνομα Πελάτη",
    accessor: "όνομα_πελάτη",
  },
  {
    Header: "Ανατεθειμένος Οδηγός",
    accessor: "ανατεθειμένος_οδηγός",
  },
  {
    Header: "Ποσό (€)",
    accessor: "ποσό",
  },
  {
    Header: "Ενέργεια",
    accessor: "ενέργεια",
  }
];

export const ProductColumn = [
  {Header: "ID",accessor:"productId"},
  { Header: "Product Name", accessor: "productName" },
  { Header: "Unit of Measure", accessor: "unitOfMeasure" },
  { Header: "Price per unit", accessor: "price" },
];

export const DriverColumn = [ 
  { Header: "Driver Name", accessor: "driverName" },
  { Header: "Email", accessor: "email" },
  { Header: "Phone Number", accessor: "phoneNumber" },
  { Header: "Assigned Clients", accessor: "assignedClients" },
];
